export const ThankYouSvg = () => {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 54 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="me-3"
    >
      <path
        d="M40.6953 31.9261L48.699 24.1032C49.6284 23.1737 51.2291 23.1737 52.1586 24.1032C52.6233 24.5679 52.8815 25.1746 52.8815 25.833C52.8815 26.4914 52.6233 27.0981 52.1586 27.5628L35.6737 44.0477C35.209 44.5124 34.6023 44.7577 33.9439 44.7577H14.8902L8.90033 50.7475L1 42.8471L12.0114 31.8357C12.9408 30.9321 14.1673 30.4415 15.4582 30.4415H38.4749C39.1978 30.4415 39.8821 30.7772 40.3597 31.3452L40.4759 31.4872C40.7599 31.9003 40.9277 32.3779 40.9277 32.8814C40.9277 33.5397 40.6695 34.1464 40.2177 34.6112C39.753 35.0759 39.1462 35.3212 38.4879 35.3212H27.6185"
        stroke="black"
      />
      <path
        d="M16.3103 2.63545C13.9093 5.1398 13.9093 9.18036 16.3103 11.6976L26.9216 22.8252C30.4587 19.1203 34.0087 15.4154 37.5457 11.7105C39.9468 9.20615 39.9468 5.16563 37.5457 2.64837C35.1447 0.144012 31.2848 0.144012 28.8837 2.64837L26.9345 4.68798L24.9723 2.63545C22.5713 0.118181 18.7114 0.118181 16.3103 2.63545Z"
        stroke="black"
      />
    </svg>
  );
};
